import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FilterButton } from 'src/components/FilterButton/FilterButton';
import { getIsMobileWithTouchscreen } from 'src/store/agent/selectors';
import { getBookingsFiltersCount } from 'src/store/bookings/selectors';
import { bookingsActions } from 'src/store/bookings/slice';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const MyBookingsFilterButton: FC = () => {
  const isMobile = useSelector(getIsMobileWithTouchscreen);

  const dispatch = useAppDispatch();
  const filtersCount = useSelector(getBookingsFiltersCount);

  const open = useCallback(() => {
    if (isMobile) {
      dispatch(bookingsActions.openFilters());
    } else {
      dispatch(sidesheetActions.open('myBookingsFilters'));
    }
  }, [dispatch, isMobile]);

  return (
    <FilterButton
      onClick={open}
      filtersCount={filtersCount}
      testId='myBookingsFilterButton'
    />
  );
};
